import {Container} from "@mantine/core";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {companySettlementSelector, useGetCompanySettlementQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useEffect, useMemo} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {LoadingPage} from "../../components/page/LoadingPage/LoadingPage";
import {ThemedPage} from "../../components/page/ThemedPage/ThemedPage";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {CompanySettlementProfile} from "../../components/profile/CompanySettlementProfile/CompanySettlementProfile";

type Props = {
  id?: string;
}

export const CompanySettlementProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage message={"Company Settlement Not Found"}/>
    );
  }

  return <CompanySettlementProfilePage id={id}/>;
};

export const CompanySettlementProfilePage = (props: Props) => {
  const {id} = props;

  const navigate = useNavigate()
  const {pathname, search, state} = useLocation()
  const {appCategory} = useApp()

  useEffect(() => {
    navigate(pathname + search, {replace: true, state: {...state, category: appCategory?.code}})
  }, [])

  const selectSettlement = useMemo(() => {
    return companySettlementSelector()
  }, []);

  const {settlement, isFetching} = useGetCompanySettlementQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      settlement: selectSettlement(result),
      isFetching: result.isFetching
    })
  });

  if (isFetching) {
    return (
      <LoadingPage/>
    );
  }

  if (!settlement) {
    return (
      <ErrorPage message={"Company Settlement Not Found"}/>
    );
  }

  return (
    <ThemedPage>
      {(classes) => (
        <Container className={classes.container} fluid={true} py="md">
          <CompanySettlementProfile companySettlement={settlement}/>
        </Container>
      )}
    </ThemedPage>
  );
};
